<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new icon-upload-bg">
      <i class="fa-solid fa-clipboard-list icon-upload"></i>
    </div>
    <div>
      <h2 class="dialog-title">Creativity Upload Report</h2>
      <p class="dialog-subtitle">Upload results summary</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onClose()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <div class="report-table-wrapper">
    <table class="report-table">
      <thead>
        <tr>
          <th>Filename</th>
          <th>Reference Code</th>
          <th>Status</th>
          <th style="width:60px">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (item of data; track $index) {
          <tr>
            <td class="filename-col">
              <div class="filename-content">
                <i class="fa-solid fa-file"></i>
                <span class="filename-text">{{ item.data?.originalFilename || 'N/A' }}</span>
              </div>
            </td>
            <td class="refcode-col">
              <span class="ref-code">{{ item.data?.referenceCode || 'N/A' }}</span>
            </td>
            <td class="status-col">
              <span [class]="item.success && item.data.status.id != 44 ? 'status-ok' : 'status-fail'">
                <i [class]="item.success && item.data.status.id != 44 ? 'fa-solid fa-check' : 'fa-solid fa-xmark'"></i>
                {{ item.success ? (item.data.status.id == 44 ? 'Spec Check Failed' : 'Success') : 'Failed' }}
              </span>
            </td>
            <td class="actions-col">
              @if( item.data != null && item.data.status.id == 44 ) {
                <button matButton class="act-btn" (click)="onViewSpecCheckReport(item.data)" matTooltip="View Spec Check Report">
                  <i class="fa-solid fa-circle-info" style="color:#DC2606"></i>
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-blue" (click)="onClose()">
    Close
  </button>
</mat-dialog-actions>
